








































































import { BAlert, BButton, BFormGroup, BFormTextarea, VBTooltip } from "bootstrap-vue";
import VariablePicker from "@/components/variablePicker.vue";
import DescriptionInputCounter from "@/views/modules/settings/whatsapp-templates/components/descriptionInputCounter.vue";
import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import EmojiPicker from "@/components/emojiPicker.vue";
import { useMessage } from "@/composables/useMessage";
import { ValidationProvider } from "vee-validate";
// @ts-ignore
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default defineComponent({
    components: {
        EmojiPicker,
        BAlert,
        BFormGroup,
        DescriptionInputCounter,
        VariablePicker,
        BFormTextarea,
        BButton,
        ValidationProvider,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        value: {
            type: String,
            required: true,
        },
        examples: {
            type: Array as PropType<string[]>,
            required: true,
        },
    },
    setup(props, { emit }) {
        const { t } = useI18nUtils();
        const templateContentTextArea = ref<HTMLInputElement>();

        const content = computed({
            get: () => props.value,
            set: (value) => emit("input", value),
        });

        const isMissingExamples = computed(() => {
            return Boolean(props.examples.filter((example) => example.trim() === "").length);
        });

        const { insertToMessage } = useMessage(templateContentTextArea, content);

        const canAddSamples = computed(() => !content.value.match(/\{\{([^}]+)\}\}/g));
        //use translateText because when we build it in production with $t we got issues where got the tooltip
        // this problems looks comes from lifecycle
        const translateText = (i18nLink) => {
            return t(i18nLink);
        };

        const totalLength = computed(() => {
            const examplesLength = props.examples.reduce((sum, ex) => sum + ex.length, 0);
            return content.value.length + examplesLength;
        });

        return {
            content,
            templateContentTextArea,
            insertToMessage,
            isMissingExamples,
            canAddSamples,
            translateText,
            totalLength,
        };
    },
});
